document.addEventListener("DOMContentLoaded", function () {
  const mobileElements = {
    toggleButton: document.querySelector(".mc-navbar__mobile-toggle"),
    closeButton: document.querySelector(".mc-navbar__mobile-close"),
    drawer: document.querySelector(".mc-navbar__mobile-drawer"),
    overlay: document.querySelector(".mc-navbar__mobile-overlay"),
    drawerContent: document.querySelector(".mc-navbar__mobile-content"),
  };

  if (!mobileElements.toggleButton || !mobileElements.drawer) return;

  function openDrawer() {
    mobileElements.drawer.classList.remove("hidden");
    mobileElements.drawer.offsetHeight;

    requestAnimationFrame(() => {
      mobileElements.drawer.classList.add("is-open");
      mobileElements.drawer.setAttribute("aria-hidden", "false");
      mobileElements.toggleButton.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    });

    setTimeout(() => {
      if (mobileElements.closeButton) mobileElements.closeButton.focus();
    }, 300);
  }

  function closeDrawer() {
    mobileElements.drawer.classList.remove("is-open");
    mobileElements.drawer.setAttribute("aria-hidden", "true");
    mobileElements.toggleButton.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";

    setTimeout(() => {
      mobileElements.drawer.classList.add("hidden");
    }, 650);

    if (mobileElements.toggleButton) mobileElements.toggleButton.focus();
  }

  // Event listeners
  mobileElements.toggleButton.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    openDrawer();
  });

  if (mobileElements.closeButton) {
    mobileElements.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
    });
  }

  if (mobileElements.overlay) {
    mobileElements.overlay.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
    });
  }

  document.addEventListener("click", (e) => {
    if (mobileElements.drawer?.classList.contains("is-open")) {
      if (
        !mobileElements.drawerContent?.contains(e.target) &&
        !mobileElements.toggleButton.contains(e.target)
      ) {
        closeDrawer();
      }
    }
  });

  document.addEventListener("keydown", (e) => {
    if (
      e.key === "Escape" &&
      mobileElements.drawer?.classList.contains("is-open")
    ) {
      closeDrawer();
    }
  });
});
